import Modal from '../modal';
import EventEmitter, { EVENT_TYPES } from '@lib/eventEmitter';

const EvBMWChargerBanner = () => {
  const openModal = () =>
    EventEmitter.emit(EVENT_TYPES.openModal, 'ev-bmw-charger-modal');
  const closeModal = () => EventEmitter.emit(EVENT_TYPES.closeModal);

  return (
    <>
      <div className="ac-promo ac-promo--ev-bmw-charger ch-flex-direction--column sm:ch-flex-direction--row">
        <p className="ac-promo__title ch-width--12 ch-fw--500 ch-color--white ch-text--center sm:ch-text--left sm:ch-mb--0">
          Get a home charger from £699 when you buy this car!
        </p>
        <button
          className="ac-promo__link ch-color--white ch-fw--500 sm:ch-fs--3 sm:ch-ml--2 ch-btn ch-btn--link ch-pa--0"
          onClick={openModal}
          type="button"
        >
          Find out more
        </button>
      </div>
      <Modal hideClose id="ev-bmw-charger-modal">
        <div className="ch-modal ch-modal--xs ev-bmw-charger-modal">
          <div className="ev-bmw-charger-modal__header">
            <button
              className="ch-modal__close"
              onClick={closeModal}
              type="button"
            >
              <span className="ch-reader">Close</span>
            </button>
          </div>
          <div className="ch-text--center ch-pa--3 ch-bg--white">
            <p className="ch-fs--4 ch-fw--600">
              Buy a new fully electric BMW and get a Bumblebee Point home
              charger from only £699.
            </p>
            <p className="ch-lh--body">
              After your purchase, our trusted partner Bumblebee will contact
              you to arrange your included installation.
            </p>
            <div>
              <a href="/terms" rel="nofollow">
                View terms and conditions
              </a>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default EvBMWChargerBanner;
